var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overHidden m-b-10 tool-box",staticStyle:{"padding-left":"60px"},attrs:{"name":"mask-title"}},[_c('span',{staticClass:"tit-span displayIB font16 textRight"},[_vm._v(_vm._s(_vm.txt))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361fa8b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mask-title.vue
// module id = null
// module chunks = 